(function () {
  'use strict';
  if (window.__snlAnalyticsLoaded) return;
  window.__snlAnalyticsLoaded = true;
  var marks = [25, 50, 75, 90, 100];
  var fired = {}, seen = {}, timer, observer;
  function allowed() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    return !!(cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed());
  }
  function track(name, data) {
    if (!allowed()) return;
    data.event = name;
    data.page = location.pathname;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  }
  function cleanHref(href) {
    try {
      var url = new URL(href, location.href);
      return /^https?:$/.test(url.protocol) ? url.origin + url.pathname : '';
    } catch (error) { return ''; }
  }
  function scrollDepth() {
    if (!allowed()) return;
    var max = document.documentElement.scrollHeight - window.innerHeight;
    if (max <= 0) return;
    var pct = Math.round(((window.scrollY || document.documentElement.scrollTop) / max) * 100);
    marks.forEach(function (mark) {
      if (pct >= mark && !fired[mark]) {
        fired[mark] = true;
        track('snl_scroll_depth', { snl_depth: mark });
      }
    });
  }
  function syncConsent() {
    if (observer) observer.disconnect();
    if (!allowed() || !('IntersectionObserver' in window)) return;
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || !allowed()) return;
        var id = entry.target.id;
        if (!id || seen[id]) return;
        seen[id] = true;
        track('snl_section_view', { snl_section: id.replace(/^shopify-section-/, '') });
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.5 });
    document.querySelectorAll('.shopify-section, [id^="shopify-section-"]').forEach(function (section) {
      if (section.offsetHeight > 40 && !seen[section.id]) observer.observe(section);
    });
  }
  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest ? event.target : null;
    if (!target) return;
    var consent = target.closest('[data-snl-consent-preferences]');
    if (consent) {
      if (window.Didomi && window.Didomi.preferences && typeof window.Didomi.preferences.show === 'function') {
        event.preventDefault(); window.Didomi.preferences.show();
      } else if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        event.preventDefault(); window.privacyBanner.showPreferences();
      } else {
        var banner = document.getElementById('cookies-banner');
        var data = banner && window.Alpine && window.Alpine.$data(banner);
        if (data && typeof data.handleManagePreferences === 'function') {
          event.preventDefault(); data.handleManagePreferences();
        }
      }
    }
    var tracked = target.closest('[data-snl-track]');
    if (tracked) track('snl_click', {
      snl_id: tracked.getAttribute('data-snl-track'),
      snl_href: cleanHref(tracked.getAttribute('href') || ''),
      snl_text: (tracked.textContent || '').trim().slice(0, 80)
    });
    var anchor = target.closest('a[data-snl-scroll]');
    if (!anchor) return;
    var href = anchor.getAttribute('href') || '';
    if (href.charAt(0) !== '#' || href.length < 2) return;
    var destination;
    try { destination = document.querySelector(href); } catch (error) { return; }
    if (!destination) return;
    event.preventDefault();
    destination.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  }, true);
  window.addEventListener('scroll', function () {
    if (!allowed()) return;
    clearTimeout(timer); timer = setTimeout(scrollDepth, 150);
  }, { passive: true });
  document.addEventListener('visitorConsentCollected', syncConsent);
  document.addEventListener('shopify:section:load', syncConsent);
  if (window.Shopify && !window.Shopify.customerPrivacy && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) { if (!error) syncConsent(); });
  } else { syncConsent(); }
})();
